import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";

import useStyles from "./useStyles";

const Title = (props) => {
  const { title, subtitle, children } = props;
  const classes = useStyles();

  return (
    <>
      <Typography variant="h2" className={classes.title}>
        {title}
      </Typography>
      {subtitle && <Typography>{subtitle}</Typography>}
      {children}
    </>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Title;
